import queryString from "query-string"

export function getQueryParam(key) {
  const queryStringParams = queryString.parse(window.location.search)
  return queryStringParams[key]
}

export function setMetaTag(id, value) {
  const elem = document.getElementById(id)
  if(elem) {
  	switch(elem.tagName) {
  		case "TITLE":
  			elem.innerHTML = value
  		break;

  		default:
  			elem.content = value
  		break;
  	}
  }
}

export function addQueryParams(params) {
	const paramsFiltered = params.filter(param => getQueryParam(param)).map(param => `${param}=${getQueryParam(param)}`)
	if(!paramsFiltered.length) {
		return ""
	}

	return `?${paramsFiltered.join('&')}`
}